import useSorting from '@rio-cloud/rio-uikit/useSorting';

export const useTableSorting = <T>(data: T[], fixedSortKey: keyof T, defaultSecondarySortKey: keyof T) => {
    const {
        sortedItems,
        sortKey: sortKeys,
        sortDirection,
        setSortKey,
        toggleDirection,
    } = useSorting<T>(data, [fixedSortKey, defaultSecondarySortKey]);

    const handleSortByColumn = (column: keyof T) => {
        setSortKey([fixedSortKey, column]);
        if (Array.isArray(sortKeys) && column === sortKeys[1]) {
            toggleDirection();
        }
    };

    const sortKey = Array.isArray(sortKeys) ? sortKeys[1] : sortKeys;
    return { sortedItems, sortKey, sortDirection, handleSortByColumn };
};
